<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div class="title">Cortesia/Teste</div>
        <div @click="$router.push('/courtesy')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form v-if="ticket" @submit.prevent="create" class="form">
        <Selector v-model="active" :options="activeOptions" class="selector_change"/>
        <label>Cliente</label>
        <input v-if="ticket !== 'new'" v-model="name" :disabled="ticket !== 'new'" type="text" placeholder="cliente" :class="{ error : error.includes('name') }" />
        <Autocomplete v-if="ticket === 'new'" v-model="customer" :list="listCustomers" placeholder="Cliente" :class="{ error : error.includes('user') }" />
        <div v-if="error.includes('id')" class="hint">você esqueceu o cliente</div>
        <!-- Profit -->
        <label class="switch">
          <input v-model="pf" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">Profit</span>
        </label>
        <!-- BlackArrow -->
        <label class="switch" style="margin-top: 0px;">
          <input v-model="ba" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">BlackArrow</span>
        </label>
        <!-- NinjaTrader -->
        <label class="switch" style="margin-top: 0px;">
          <input v-model="nj" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">NinjaTrader</span>
        </label>
        <!-- NinjaTrader Bot Yan -->
        <label class="switch" style="margin-top: 0px;">
          <input v-model="nj_botyan" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">Ninja - Bot Yan</span>
        </label>
        <!-- Profit Bot Yan-->
        <label class="switch">
          <input v-model="pf_botyan" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">Profit - Bot Yan</span>
        </label>
        <!-- BlackArrow Bot Yan-->
        <label class="switch" style="margin-top: 0px;">
          <input v-model="ba_botyan" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">BlackArrow - Bot Yan</span>
        </label>
        <!-- Dashboard -->
        <label class="switch" style="margin-top: 0px;">
          <input v-model="dashboard" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">Dashboard</span>
        </label>
        <!-- Validade -->
        <label>Validade</label>
        <input v-model="expiration" v-on:keydown="validade" type="date" :min="(new Date()).toISOString().split('T')[0]" :class="{ error : error.indexOf('expiration') > -1 }"/>
        <div v-if="error.indexOf('expiration') > -1" class="hint">Validade inválida</div>
        <div v-if="error.includes('internal')" class="hint">Erro interno! Tente novamente.</div>
        <div class="actions">
          <button @click="$router.push('/courtesy')" class="button-previous"><i class="fas fa-angle-left"></i><span>Cancelar</span></button>
          <!-- v-if="newProduct || period || !active" -->
          <button @click="save" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Salvar</span></button>
        </div>
        <!--<button type="submit" class="button-save" style="margin-top: 30px"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>-->
      </form>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { create, update } from '../api/courtesy'
import { getAll as getCustomers } from '../api/customer'
import Selector from './Selector'
import Autocomplete from './Autocomplete'

export default {
  components: { Autocomplete, Selector },
  props: ['ticket', 'ticketData', 'close'],
  data () {
    return {
      error: [],
      loading: false,
      shows: [],
      show: null,
      customers: [],
      customer: null,
      showsSelected: [],
      expiration: null,
      maxDate: null,
      pf: false,
      nj: false,
      ba: false,
      nj_botyan: false,
      pf_botyan: false,
      ba_botyan: false,
      dashboard: false,
      active: false,
      activeOptions: [
        {
          value: true,
          text: 'ATIVADO'
        },
        {
          value: false,
          text: 'DESATIVAR'
        }
      ]
    }
  },
  computed: {
    listCustomers () {
      return this.customers.map(x => ({
        id: x.userId,
        name: x.name,
        detail: `${x.login} | ${x.phone}`
      }))
    }
  },
  async mounted () {
    if (this.ticket !== 'new') {
      this.name = this.ticketData.name
      if (this.ticketData.ninja) {
        this.nj = true
        this.expiration = this.ticketData.ninja
      }
      if (this.ticketData.profit) {
        this.pf = true
        this.expiration = this.ticketData.profit
      }
      if (this.ticketData.black) {
        this.ba = true
        this.expiration = this.ticketData.black
      }
      if (this.ticketData.ninjaBotYan) {
        this.nj_botyan = true
        this.expiration = this.ticketData.ninjaBotYan
      }
      if (this.ticketData.profitBotYan) {
        this.pf_botyan = true
        this.expiration = this.ticketData.profitBotYan
      }
      if (this.ticketData.blackBotYan) {
        this.ba_botyan = true
        this.expiration = this.ticketData.blackBotYan
      }
      if (this.ticketData.dashboard) {
        this.dashboard = true
        this.expiration = this.ticketData.dashboard
      }
      this.expiration = String(this.expiration).split(' ')[0]
      const data = String(this.expiration).split('/')
      this.expiration = data[2] + '-' + data[1] + '-' + data[0]
      this.active = true
    } else {
      this.active = true
      try {
        const date = new Date()
        const results = await Promise.all([
          getCustomers('2000-01-01', date.toISOString().split('T')[0])
        ])
        this.customers = results[0]
      } catch (error) {
        logger.error(error)
      }
    }
  },
  methods: {
    validade (e) {
      e.preventDefault()
    },
    async save () {
      try {
        if (this.loading) return false
        this.loading = true
        this.error = []
        if (this.ticket !== 'new') {
          await update(this.ticketData.id, this.pf, this.ba, this.nj, this.expiration, this.active, this.nj_botyan, this.pf_botyan, this.ba_botyan, this.dashboard)
          this.close()
        } else {
          await create(this.customer, this.pf, this.ba, this.nj, this.expiration, this.active, this.nj_botyan, this.pf_botyan, this.ba_botyan, this.dashboard)
          this.close()
        }
        this.loading = false
        this.$router.push('/courtesy')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    },
    async create () {
      try {
        this.loading = true
        this.error = []
        const customer = this.customers.find(x => x.userId === this.customer)
        if (!customer) {
          this.error = ['user']
          return
        }
        await create(
          this.showsSelected,
          customer.userId,
          customer.login
        )
        this.close()
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          this.error = ['internal']
          logger.error(error)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.selector_change {
    background-color: #cccccc;
    color: #595959;
    font-size: 0.8em;
    padding: 2.5px;
}
.pay-label {
  color: $primary-color;
  font-weight: 500;
  font-size: 0.85em;
}

.pay-value {
  margin-top: 3px;
  color: #777;
  max-height: 100px;
  overflow-y: auto;
}

.list-shows {
  display: flex;
  align-items: center;
  color: $lp-text-2;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px;
  margin-top: 2px;
  span {
    flex-grow: 1;
  }
  i {
    color: $primary-color;
    cursor: pointer;
  }
}
</style>
